import {
  Block,
  Check,
  Delete,
  ErrorOutline,
  HourglassEmpty,
  Pending,
  Sync,
} from '@mui/icons-material';
import { Chip, ChipProps, Tooltip, keyframes } from '@mui/material';
import { blue, green, grey, orange, red } from '@mui/material/colors';
import { MeterTaskStatus } from 'switch-shared/modules/crud/meter-task/meter-task.entity';

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  70% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

interface Props {
  type: MeterTaskStatus;
  backedOffCount?: number;
  backedOffUntil?: Date | string;
  size?: ChipProps['size'];
}

export const MeterTaskStatusChip = ({
  type,
  backedOffCount = 0,
  backedOffUntil,
  size,
}: Props) => {
  switch (type) {
    case 'completed':
      return (
        <Chip
          size={size}
          label={'Success'}
          sx={{ backgroundColor: green[400] }}
          icon={<Check style={{ color: 'white' }} />}
        />
      );
    case 'failed':
      return (
        <Chip
          size={size}
          label={'Failed'}
          sx={{ backgroundColor: red[400], color: 'white' }}
          icon={<ErrorOutline style={{ color: 'white' }} />}
        />
      );
    case 'cancelled':
      return (
        <Chip
          size={size}
          label={'Cancelled'}
          sx={{ backgroundColor: grey[500], color: 'white' }}
          icon={<Block style={{ color: 'white' }} />}
        />
      );
    case 'claimed':
      return (
        <Chip
          size={size}
          label={'Claimed'}
          sx={{ backgroundColor: blue[400] }}
          icon={<Sync style={{ color: 'white' }} />}
        />
      );
    case 'pending':
      const isBackedOff =
        backedOffUntil && new Date(backedOffUntil).getTime() > Date.now();
      return (
        <Chip
          size={size}
          label={isBackedOff ? `Retrying (${backedOffCount})` : 'Pending'}
          sx={{
            backgroundColor: orange[400],
            color: 'white',
            ...(isBackedOff
              ? {}
              : {
                  '& .MuiChip-icon': {
                    animation: `${rotateAnimation} 2s cubic-bezier(0.55, 0.055, 0.675, 0.19) infinite`,
                  },
                }),
          }}
          icon={
            isBackedOff ? (
              <HourglassEmpty style={{ color: 'white' }} />
            ) : (
              <Pending style={{ color: 'white' }} />
            )
          }
        />
      );
    default:
      return <Chip size={size} label='Unknown' />;
  }
};
